import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, shareReplay, throwError } from 'rxjs';
import { LabService, VideoStatusService as VideoStatusApiService } from '@solverml/api';

export interface RelaunchPipelineResponse {
  status: string;
  message: string;
  video_id?: string;
  orchestrator_state?: string;
}
@Injectable({
  providedIn: 'root'
})
export class VideoLabService {
  private internalAccess$?: Observable<boolean>;
  private readonly backendBaseUrl = `${window.location.protocol}//backend.${window.location.hostname}`;

  constructor(
    private labService: LabService,
    private videoStatusApi: VideoStatusApiService,
  ) { }

  checkInternalAccess(): Observable<boolean> {
    if (!this.internalAccess$) {
      this.internalAccess$ = this.labService.checkInternalAccess().pipe(
        map((resp: any) => {
          if (typeof resp === 'boolean') return resp;
          return Boolean(resp?.access);
        }),
        catchError(() => of(false)),
        shareReplay(1)
      );
    }

    return this.internalAccess$;
  }

  /**
   * Relanza la pipeline de IA para un vídeo.
   */
  relaunchPipeline(videoId: string, forceRestart: boolean = false): Observable<RelaunchPipelineResponse> {
    return this.labService.relaunchAiPipeline(videoId, forceRestart) as Observable<RelaunchPipelineResponse>;
  }

  relaunchAllReadyPipelines(): Observable<any> {
    return this.labService.relaunchAiPipelineAll();
  }

  archiveVideo(videoId: string): Observable<any> {
    const api: any = this.videoStatusApi as any;
    if (typeof api.archiveVideoStatus !== 'function') {
      return throwError(() => new Error('archiveVideoStatus no está disponible en el cliente API.'));
    }
    return api.archiveVideoStatus(videoId);
  }

  prioritizeVideoInQueue(videoId: string): Observable<any> {
    return this.videoStatusApi.prioritizeVideoInQueue(videoId);
  }
}
